import bindAllMethods from '../../../utils/bindAllMethods';
import { getServices } from '../../../infra/startup';
import { IEligibilityService } from '../../../services/eligibilityService/IEligibilityService';
import { EligibilityRuleEvaluation } from '../../../services/eligibilityService/types';
import {
  CheckEligibilityParams,
  EligibilityInterfaceType
} from '@clientos/types';

export class EligibilityInterfaceV1 {
  private readonly _eligibilityService: IEligibilityService;

  constructor() {
    const services = getServices();
    this._eligibilityService = services.eligibilityService;

    bindAllMethods(this);
  }

  public getInterface(): EligibilityInterfaceType {
    return {
      checkEligibility: this._checkEligibility
    };
  }

  private async _checkEligibility({
    rules,
    isPublic
  }: CheckEligibilityParams): Promise<EligibilityRuleEvaluation[]> {
    return this._eligibilityService.checkEligibility(rules, isPublic);
  }
}

export default EligibilityInterfaceV1;
